import { createSelector } from 'reselect'
import {
  getThe,
  getTheBoolean,
  select,
  every,
  some,
} from './utils'

const getValuation = state => state.valuation
const selectFromValuation = select(getValuation)

export const selectRequestedValuationAmount = selectFromValuation(
  getThe('requestedAmount')
)
export const selectRequestedValuationType = selectFromValuation(
  getThe('requestedType')
)
export const selectRequestedValuationUpdated = selectFromValuation(
  getThe('requestedUpdate')
)
export const selectRequestedValuationSuccess = selectFromValuation(
  getTheBoolean('success')
)
export const selectRequestedValuationFailure = selectFromValuation(
  getTheBoolean('failure')
)
export const selectHomeRefreshRequired = selectFromValuation(
  getTheBoolean('needsRefresh')
)
export const selectRequestedValuationError = selectFromValuation(
  getThe('error')
)

export const selectHomeFactsProgress = selectFromValuation(getThe('progress'))

export const selectValuationRequested = createSelector(
  selectRequestedValuationAmount,
  selectRequestedValuationType,
  every
)

export const selectValuationRequestReturned = createSelector(
  selectRequestedValuationSuccess,
  selectRequestedValuationFailure,
  some
)
